<mat-card
  [@toggleHide]="'in'"
  class="sidebar brand_color_bg"
  *ngIf="!hide"
  [class.open]="!collapse">
  <ul class="sidebar_links">
    <li class="sidebar_item sidebar_item_logo logo" routerLink="/profile">
      <div class="logo_image">
        <img src="/assets/attractor-logo.png" width="40" alt="logo" />
      </div>

      <div *ngIf="!collapse" class="logo_text">
        <div class="logo_text_main">attractor</div>
        <div class="logo_text_small">school CRM</div>
      </div>
    </li>

    <li *ngFor="let item of commonMenu" (click)="linkHandler()">
      <a
        [routerLink]="item.link"
        [queryParams]="item.query ? item.query : null"
        routerLinkActive="is-active"
        class="sidebar_item sidebar_item_link">
        <ng-container *appCheckPermissions="[userRoles.admin]">
          <div
            *ngIf="item.name === 'Пользователи' && unconfirmedUsersCount"
            class="d-flex position-absolute">
            <app-qty-label
              [number]="unconfirmedUsersCount"
              size="17px"></app-qty-label>
          </div>
        </ng-container>

        <div>
          <fa-icon
            class="sidebar_icon"
            [icon]="item.icon"
            matTooltipDisabled="{{ !collapse }}"
            matTooltipPosition="right"
            matTooltip="{{ item.name }}"></fa-icon>
        </div>
        <span class="sidebar_text" *ngIf="!collapse">{{ item.name }}</span>
      </a>
    </li>

    <li
      class="my-3 sidebar_item sidebar_item_link"
      *appCheckPermissions="[
        userRoles.admin,
        userRoles.mentor,
        userRoles.student,
        userRoles.teacher,
        userRoles.sales_managers,
        userRoles.sales_admin,
        userRoles.accountant
      ]">
      <div [matMenuTriggerFor]="menu" class="d-flex align-items-center">
        <mat-icon
          class="mx-2"
          matTooltip="Сменить тему оформления"
          matTooltipPosition="right">
          invert_colors
        </mat-icon>
        <mat-menu #menu="matMenu" class="p-3 theme-menu" xPosition="after">
          <div class="bg_hover p-2 w-100" (click)="setTheme('light')">
            Светлая
          </div>
          <div class="bg_hover p-2 w-100" (click)="setTheme('dark')">
            Темная
          </div>
        </mat-menu>
        <p *ngIf="!collapse" class="m-0">Тема</p>
      </div>
    </li>

    <li class="sidebar_item sidebar_item_link">
      <a
        (click)="logout()"
        class="d-flex align-items-center sidebar_item sidebar_item_link">
        <mat-icon class="mx-2" matTooltip="Выйти" matTooltipPosition="right">
          meeting_room
        </mat-icon>
        <span *ngIf="!collapse" class="m-0">Выйти</span>
      </a>
    </li>
  </ul>

  <div
    (click)="close()"
    matTooltipDisabled="{{ !collapse }}"
    matTooltip="Развернуть меню"
    class="sidebar_item sidebar_item_link sidebar_item_collapse">
    <fa-icon
      class="sidebar_icon"
      *ngIf="!collapse"
      [icon]="faLeftArrow"></fa-icon>
    <fa-icon
      class="sidebar_icon"
      *ngIf="collapse"
      [icon]="faRightArrow"></fa-icon>
    <span class="sidebar_text" *ngIf="!collapse">Скрыть меню</span>
  </div>
</mat-card>
<div class="sidebar_hide_icon icon" (click)="toggleHide()">
  <fa-icon [icon]="faMenu"></fa-icon>
</div>
<app-backdrop (click)="toggleHide()" *ngIf="isMobile && !hide"></app-backdrop>
